<div class="app-modal__overlay" (click)="onOverlayClick($event)">
  <div class="app-modal__card" [style.width]="width() || null" [style.max-width]="maxWidth() || null">
    @if (!hideClose()) {
      <button type="button" class="app-modal__close" (click)="onClose()">
        <img [src]="isDark() ? 'assets/icons/close-circle-dark.svg' : 'assets/icons/close-circle-light.svg'" alt="Close" />
      </button>
    }

    @if (title()) {
      <h2 class="app-modal__title">{{ title() }}</h2>
    }

    <ng-content />
  </div>
</div>
